import { render } from "./ModalLisance.vue?vue&type=template&id=1b71891e&scoped=true"
import script from "./ModalLisance.vue?vue&type=script&lang=js"
export * from "./ModalLisance.vue?vue&type=script&lang=js"

import "./ModalLisance.vue?vue&type=style&index=0&id=1b71891e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b71891e"]])

export default __exports__